import React from "react"

import Grid from "@material-ui/core/Grid"
import styled from "styled-components"
import FiveStars from "../../images/five-stars.png"
import { useStaticQuery, graphql } from "gatsby"
import { setRem, setColor, media } from "../../style"

const getData = graphql`
  {
    testimonials: allContentfulTestimonials(
      
      sort: {fields: testimonialDate, order: DESC}, 
      limit: 3,
      filter: { isInHome: { eq: false } }
    ) {
      edges {
        node {
          id
          poster
          testimonialDate(formatString: "MMM, YYYY")
          title
          testimonial {
            testimonial
          }
          typeOfStay
          dateOfStay
        }
      }
    }
  }
`

const Testimonials = () => {
  const data = useStaticQuery(getData)
  const testimonials = data.testimonials.edges
  return (
    <Container>
      <div className="testimonials">
        {testimonials.map( (nodo,i) => (
          <Testimonial nodo={nodo} key={i} />
        ))}
      </div>
      <div className="extras">
        {testimonials.map((nodo,i) => (
          <Extras nodo={nodo} key={i} />
        ))}
      </div>
    </Container>
  )
}

export default Testimonials

const Testimonial = ({ nodo }) => {
  const {
    poster,
    testimonialDate,
    title,
    testimonial,
    typeOfStay,
    dateOfStay,
  } = nodo.node

  return (
    
      <div className="testimonial">
        <span className="poster">{poster}</span>
        <span className="date"> {testimonialDate}</span>
        <br />
        <img src={FiveStars} alt="Five Stars" />
        <div className="title">{title}</div>
        <div className="text">"{testimonial.testimonial}"</div>

        <div className="extra-movil">
          <b>Type of Stay:</b> {typeOfStay}
          <br />
          <b>Date of Stay:</b> {dateOfStay}
          <br />
        </div>
      </div>
    
  )
}

const Extras = ({ nodo }) => {
  const { id, typeOfStay, dateOfStay } = nodo.node

  return (
    <Grid id={id} item xs={12} sm>
      <div className="testimonial">
        <br />
        <b>Type of Stay:</b> {typeOfStay}
        <br />
        <b>Date of Stay:</b> {dateOfStay}
      </div>
    </Grid>
  )
}

const Container = styled.div`
  padding: 1rem;
  font-size: ${setRem(12)};
  ${media.tablet`
    padding: 3rem;
  `}
  
  
  .testimonials {
    ${media.tablet `
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    `}
  }
  
  .testimonial {
    padding: 0px ${setRem(15)};
    white-space: pre-wrap;
    margin-top: ${setRem(10)};

  }
  .poster {
    font-size: ${setRem(20)};
    font-weight: bold;
  }
  .title {
    font-size: ${setRem(12)};
    font-weight: bold;
  }

  .date {
    font-size: ${setRem(12)};
    color: ${setColor.secondaryColor};
  }

  .extras {
    display: none;
    ${media.tablet `
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
    `}
  }

  .extra-movil {
    display: normal;
    ${media.tablet`
      display: none;
    `}
  }
`
